module.exports = {"410928100":"城关镇","410928101":"濮阳县柳屯镇","410928102":"濮阳县文留镇","410928103":"濮阳县庆祖镇","410928104":"濮阳县八公桥镇","410928106":"濮阳县徐镇镇","410928107":"濮阳县户部寨镇","410928108":"濮阳县鲁河镇","410928109":"濮阳县子岸镇","410928110":"濮阳县胡状镇","410928111":"濮阳县王称固镇","410928112":"濮阳县梁庄镇","410928202":"濮阳县清河头乡","410928206":"濮阳县白罡乡","410928207":"濮阳县梨园乡","410928208":"濮阳县五星乡","410928211":"濮阳县郎中乡","410928212":"濮阳县海通乡","410928213":"濮阳县渠村乡","410928214":"濮阳县习城乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410928.json
// module id = 1735
// module chunks = 0